<script setup>
import { computed, defineProps } from 'vue';
import { currencyUtil } from '@/utils';

const props = defineProps({
  preco: {
    type: String,
    default: '',
  },
  sizeIcon: {
    type: Number,
    default: 15,
  },
  decimal: {
    type: Number,
    default: 2,
  },
});

const defineColor = computed(() => (props.preco > 0 ? 'text-success' : 'text-danger'));
const defineIcon = computed(() => (props.preco > 0 ? 'arrow-up' : 'arrow-down'));
</script>

<template>
  <div class="d-flex align-items-center justify-content-end" :class="defineColor" v-if="preco != 0.00">
    <vue-feather :type="defineIcon" :size="sizeIcon"></vue-feather>
    <span>{{ currencyUtil.formatCurrency(props.preco, props.decimal) }}</span>
  </div>
</template>
